module.exports = __webpack_public_path__ + "static/media/feature.bc071481.png";